module.exports = __webpack_public_path__ + "img/congo,-democratic-republic-of-the.59114398.svg";